module.exports = __webpack_public_path__ + "static/media/20230609.6ab2568a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/banner/20230609/img/20230609.jpg
// module id = 312
// module chunks = 0